import _ from "lodash";

// ivMap is the same as NetworkAPI.getInventoryRegistry()
const ivMap = {
  1: {
    k: "1_0010",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  2: {
    k: "1_0011",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  3: {
    k: "1_0020",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  4: {
    k: "1_0021",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  5: {
    k: "1_0110",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  6: {
    k: "1_0111",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  7: {
    k: "1_0120",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  8: {
    k: "1_0121",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  9: {
    k: "1_0310",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  10: {
    k: "1_0311",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  11: {
    k: "1_0320",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  12: {
    k: "1_0321",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  13: {
    k: "1_0610",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  14: {
    k: "1_0611",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  15: {
    k: "1_0620",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  16: {
    k: "1_0621",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  17: {
    k: "1_0810",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  18: {
    k: "1_0811",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  19: {
    k: "1_0820",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  20: {
    k: "1_0821",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  21: {
    k: "1_2410",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  22: {
    k: "1_2411",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  23: {
    k: "1_2420",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  24: {
    k: "1_2421",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  25: {
    k: "1_2510",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  26: {
    k: "1_2511",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  27: {
    k: "1_2520",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  28: {
    k: "1_2521",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  29: {
    k: "1_3210",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  30: {
    k: "1_3211",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  31: {
    k: "1_3220",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  32: {
    k: "1_3221",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  33: {
    k: "1_3310",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  34: {
    k: "1_3311",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  35: {
    k: "1_3320",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  36: {
    k: "1_3321",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  37: {
    k: "1_3610",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  38: {
    k: "1_3611",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  39: {
    k: "1_3620",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  40: {
    k: "1_3621",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  41: {
    k: "1_3810",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  42: {
    k: "1_3811",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  43: {
    k: "1_3820",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  44: {
    k: "1_3821",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  45: {
    k: "2_0000",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  46: {
    k: "2_0001",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  47: {
    k: "2_0002",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  48: {
    k: "2_000z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  49: {
    k: "2_0030",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  50: {
    k: "2_0031",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  51: {
    k: "2_0032",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  52: {
    k: "2_003z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "out_of_page", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  53: {
    k: "2_0100",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  54: {
    k: "2_0101",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  55: {
    k: "2_0102",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  56: {
    k: "2_010z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  57: {
    k: "2_0130",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  58: {
    k: "2_0131",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  59: {
    k: "2_0132",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  60: {
    k: "2_013z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "anchor", value: 1 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  61: {
    k: "2_0300",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  62: {
    k: "2_0301",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  63: {
    k: "2_0302",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  64: {
    k: "2_030z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  65: {
    k: "2_0330",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  66: {
    k: "2_0331",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  67: {
    k: "2_0332",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  68: {
    k: "2_033z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  69: {
    k: "2_0600",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  70: {
    k: "2_0601",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  71: {
    k: "2_0602",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  72: {
    k: "2_060z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  73: {
    k: "2_0630",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  74: {
    k: "2_0631",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  75: {
    k: "2_0632",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  76: {
    k: "2_063z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  77: {
    k: "2_0800",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  78: {
    k: "2_0801",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  79: {
    k: "2_0802",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  80: {
    k: "2_080z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  81: {
    k: "2_0830",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  82: {
    k: "2_0831",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  83: {
    k: "2_0832",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  84: {
    k: "2_083z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  85: {
    k: "2_2400",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  86: {
    k: "2_2401",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  87: {
    k: "2_2402",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  88: {
    k: "2_240z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  89: {
    k: "2_2430",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  90: {
    k: "2_2431",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  91: {
    k: "2_2432",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  92: {
    k: "2_243z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_audio", value: 4 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  93: {
    k: "2_2500",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  94: {
    k: "2_2501",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  95: {
    k: "2_2502",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  96: {
    k: "2_250z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  97: {
    k: "2_2530",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  98: {
    k: "2_2531",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  99: {
    k: "2_2532",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  100: {
    k: "2_253z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "instream_video", value: 5 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  101: {
    k: "3_010",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  102: {
    k: "3_011",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  103: {
    k: "3_020",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  104: {
    k: "3_021",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  105: {
    k: "3_210",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  106: {
    k: "3_211",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  107: {
    k: "3_220",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  108: {
    k: "3_221",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  109: {
    k: "3_310",
    v: {
      rt: { key: "mobile", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  110: {
    k: "3_311",
    v: {
      rt: { key: "mobile", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  111: {
    k: "3_320",
    v: {
      rt: { key: "mobile", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  112: {
    k: "3_321",
    v: {
      rt: { key: "mobile", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  113: {
    k: "4_000",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  114: {
    k: "4_001",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  115: {
    k: "4_002",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  116: {
    k: "4_00z",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  117: {
    k: "4_030",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  118: {
    k: "4_031",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  119: {
    k: "4_032",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  120: {
    k: "4_03z",
    v: {
      rt: { key: "gpt", value: 0 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  121: {
    k: "4_200",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  122: {
    k: "4_201",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  123: {
    k: "4_202",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  124: {
    k: "4_20z",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  125: {
    k: "4_230",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  126: {
    k: "4_231",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  127: {
    k: "4_232",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  128: {
    k: "4_23z",
    v: {
      rt: { key: "video", value: 2 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  129: {
    k: "1_0z10",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  130: {
    k: "1_0z11",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  131: {
    k: "1_0z20",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  132: {
    k: "1_0z21",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  133: {
    k: "1_2z10",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  134: {
    k: "1_2z11",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  135: {
    k: "1_2z20",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  136: {
    k: "1_2z21",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  137: {
    k: "1_3z10",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  138: {
    k: "1_3z11",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  139: {
    k: "1_3z20",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  140: {
    k: "1_3z21",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  141: {
    k: "2_0z00",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  142: {
    k: "2_0z01",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  143: {
    k: "2_0z02",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  144: {
    k: "2_0z0z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  145: {
    k: "2_0z30",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  146: {
    k: "2_0z31",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  147: {
    k: "2_0z32",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  148: {
    k: "2_0z3z",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  149: {
    k: "2_2z00",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  150: {
    k: "2_2z01",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  151: {
    k: "2_2z02",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  152: {
    k: "2_2z0z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  153: {
    k: "2_2z30",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  154: {
    k: "2_2z31",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  155: {
    k: "2_2z32",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  156: {
    k: "2_2z3z",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  157: {
    k: "1_1310",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  158: {
    k: "1_1311",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  159: {
    k: "1_1320",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  160: {
    k: "1_1321",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  161: {
    k: "2_1300",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "chrome", value: 0 },
    },
  },
  162: {
    k: "2_1301",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "safari", value: 1 },
    },
  },
  163: {
    k: "2_1302",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "edge", value: 2 },
    },
  },
  164: {
    k: "2_130z",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "desktop", value: 0 },
      browser: { key: "others", value: 35 },
    },
  },
  165: {
    k: "2_1330",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "chrome", value: 0 },
    },
  },
  166: {
    k: "2_1331",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "safari", value: 1 },
    },
  },
  167: {
    k: "2_1332",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "edge", value: 2 },
    },
  },
  168: {
    k: "2_133z",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      browser: { key: "others", value: 35 },
    },
  },
  169: {
    k: "0_0yyyy",
    v: {
      rt: { key: "gpt", value: 0 },
      ivf: { key: "error", value: 34 },
      dc: { key: "error", value: 34 },
      os: { key: "error", value: 34 },
      browser: { key: "error", value: 34 },
    },
  },
  170: {
    k: "0_1yyyy",
    v: {
      rt: { key: "amp", value: 1 },
      ivf: { key: "error", value: 34 },
      dc: { key: "error", value: 34 },
      os: { key: "error", value: 34 },
      browser: { key: "error", value: 34 },
    },
  },
  171: {
    k: "0_2yyyy",
    v: {
      rt: { key: "video", value: 2 },
      ivf: { key: "error", value: 34 },
      dc: { key: "error", value: 34 },
      os: { key: "error", value: 34 },
      browser: { key: "error", value: 34 },
    },
  },
  172: {
    k: "0_3yyyy",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "error", value: 34 },
      dc: { key: "error", value: 34 },
      os: { key: "error", value: 34 },
      browser: { key: "error", value: 34 },
    },
  },
  173: {
    k: "1_3710",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "ios", value: 0 },
    },
  },
  174: {
    k: "1_3711",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "smartphone", value: 1 },
      os: { key: "android", value: 1 },
    },
  },
  175: {
    k: "1_3720",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "tablet", value: 2 },
      os: { key: "ios", value: 0 },
    },
  },
  176: {
    k: "1_3721",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "tablet", value: 2 },
      os: { key: "android", value: 1 },
    },
  },
  177: {
    k: "1_3230",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  178: {
    k: "1_3231",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "app_open", value: 2 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
  179: {
    k: "1_3330",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  180: {
    k: "1_3331",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "banner", value: 3 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
  181: {
    k: "1_3630",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  182: {
    k: "1_3631",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "interstitial", value: 6 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
  183: {
    k: "1_3730",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  184: {
    k: "1_3731",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "native_advance", value: 7 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
  185: {
    k: "1_3830",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  186: {
    k: "1_3831",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "rewarded", value: 8 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
  187: {
    k: "1_3z30",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "ios", value: 0 },
    },
  },
  188: {
    k: "1_3z31",
    v: {
      rt: { key: "mobile", value: 3 },
      ivf: { key: "others", value: 35 },
      dc: { key: "connecttv", value: 3 },
      os: { key: "android", value: 1 },
    },
  },
};
const trafficGroupMap = {
  0: { type: "b", layer: 1 },
  1: { type: "o", layer: 1 },
  2: { type: "d1", layer: 1 },
  3: { type: "d2", layer: 1 },
  4: { type: "d3", layer: 1 },
  5: { type: "d4", layer: 1 },
  6: { type: "d5", layer: 1 },
  7: { type: "d6", layer: 1 },
  8: { type: "d7", layer: 1 },
  9: { type: "d8", layer: 1 },
  a: { type: "d9", layer: 1 },
  b: { type: "d10", layer: 1 },
  c: { type: "d1", layer: 1 },
  d: { type: "d2", layer: 1 },
  e: { type: "d3", layer: 1 },
  f: { type: "d4", layer: 1 },
  g: { type: "d5", layer: 1 },
  h: { type: "o", layer: 2 },
  i: { type: "d1", layer: 2 },
  j: { type: "d2", layer: 2 },
  k: { type: "d3", layer: 2 },
  l: { type: "d4", layer: 2 },
  m: { type: "d5", layer: 2 },
  n: { type: "d6", layer: 2 },
  o: { type: "d7", layer: 2 },
  p: { type: "d8", layer: 2 },
  q: { type: "d9", layer: 2 },
  r: { type: "d10", layer: 2 },
  s: { type: "d1", layer: 2 },
  t: { type: "d2", layer: 2 },
  u: { type: "d3", layer: 2 },
  v: { type: "d4", layer: 2 },
  w: { type: "d5", layer: 2 },
  x: { type: "x", layer: 1 },
  y: { type: "x", layer: 2 },
};
const timeSliceMap = {
  0: { startHour: 0, timeSpan: 1 },
  1: { startHour: 1, timeSpan: 1 },
  2: { startHour: 2, timeSpan: 1 },
  3: { startHour: 3, timeSpan: 1 },
  4: { startHour: 4, timeSpan: 1 },
  5: { startHour: 5, timeSpan: 1 },
  6: { startHour: 6, timeSpan: 1 },
  7: { startHour: 7, timeSpan: 1 },
  8: { startHour: 8, timeSpan: 1 },
  9: { startHour: 9, timeSpan: 1 },
  a: { startHour: 10, timeSpan: 1 },
  b: { startHour: 11, timeSpan: 1 },
  c: { startHour: 12, timeSpan: 1 },
  d: { startHour: 13, timeSpan: 1 },
  e: { startHour: 14, timeSpan: 1 },
  f: { startHour: 15, timeSpan: 1 },
  g: { startHour: 16, timeSpan: 1 },
  h: { startHour: 17, timeSpan: 1 },
  i: { startHour: 18, timeSpan: 1 },
  j: { startHour: 19, timeSpan: 1 },
  k: { startHour: 20, timeSpan: 1 },
  l: { startHour: 21, timeSpan: 1 },
  m: { startHour: 22, timeSpan: 1 },
  n: { startHour: 23, timeSpan: 1 },
  o: { startHour: 0, timeSpan: 3 },
  p: { startHour: 3, timeSpan: 3 },
  q: { startHour: 6, timeSpan: 3 },
  r: { startHour: 9, timeSpan: 3 },
  s: { startHour: 12, timeSpan: 3 },
  t: { startHour: 15, timeSpan: 3 },
  u: { startHour: 18, timeSpan: 3 },
  v: { startHour: 21, timeSpan: 3 },
  w: { startHour: 0, timeSpan: 6 },
  x: { startHour: 6, timeSpan: 6 },
  y: { startHour: 12, timeSpan: 6 },
  z: { startHour: 18, timeSpan: 6 },
};

export function k16ToReadable(k16) {
  let ivCode;
  let groupInfo = null;

  if (k16.startsWith("-")) {
    ivCode = k16.slice(1, 3);
  } else {
    ivCode = k16.slice(0, 2);
    groupInfo = trafficGroupMap[k16.slice(2, 3)];
  }

  const ivCodeBase10 = parseInt(ivCode, 36).toString(10);
  const ivInfo = ivMap[ivCodeBase10];

  return {
    ...((ivInfo && ivInfo.v) || {}),
    groupInfo,
  };
}

export function k20ToReadable(k20) {
  const ivCode = k20.slice(0, 2);
  const ivCodeBase10 = parseInt(ivCode, 36).toString(10);
  const ivInfo = ivMap[ivCodeBase10];

  const groupInfo = trafficGroupMap[k20.slice(2, 3)];

  const timeSliceInfo = timeSliceMap[k20.slice(3, 4)];

  return {
    ...((ivInfo && ivInfo.v) || {}),
    groupInfo,
    timeSliceInfo,
  };
}

export function readableToString(params) {
  const list = [];
  const ivList = [];
  _.keys(params).forEach((key) => {
    if (key === "groupInfo") {
      if (params[key]) {
        list.push(`${params[key].type}-L${params[key].layer}`);
      }
    } else if (key === "timeSliceInfo") {
      if (params[key]) {
        list.push(`start-${params[key].startHour}-${params[key].timeSpan}`);
      }
    } else {
      ivList.push(params[key].key);
    }
  });

  return (
    ivList.join("+") +
    (list.length > 0 && ivList.length > 0 ? " / " : "") +
    `${list.join(" / ")}`
  );
}

export function getMapValue() {
  const result = {};
  const groupType = [];
  const groupLayer = [];
  const startHourList = [];
  const timeSpanList = [];
  _.keys(ivMap).forEach((key) => {
    const iv = ivMap[key];
    _.keys(iv.v).forEach((k) => {
      if (!result[k]) {
        result[k] = [];
      }
      if (result[k].indexOf(iv.v[k].key) === -1) {
        result[k].push(iv.v[k].key);
      }
    });
  });

  _.keys(trafficGroupMap).forEach((key) => {
    const { type, layer } = trafficGroupMap[key];
    if (groupType.indexOf(type) === -1) {
      groupType.push(type);
    }
    if (groupLayer.indexOf(layer) === -1) {
      groupLayer.push(layer);
    }
  });

  _.keys(timeSliceMap).forEach((key) => {
    const { startHour, timeSpan } = timeSliceMap[key];
    if (startHourList.indexOf(startHour) === -1) {
      startHourList.push(startHour);
    }
    if (timeSpanList.indexOf(timeSpan) === -1) {
      timeSpanList.push(timeSpan);
    }
  });

  return {
    ivInfo: result,
    groupInfo: {
      groupType: [
        "d1",
        "d2",
        "d3",
        "d4",
        "d5",
        "d6",
        "d7",
        "d8",
        "d9",
        "d10",
        "b",
        "o",
        "x",
      ],
      groupLayer,
    },
    timeSliceInfo: {
      startHour: startHourList,
      timeSpan: timeSpanList,
    },
  };
}

export function upaPriceToReadable(upaPrice) {
  const priceSplit = upaPrice.split("_");

  function parsePrice(price) {
    return _.toNumber((_.toNumber(price) / 100).toFixed(2));
  }

  // ex. 201
  if (priceSplit.length === 1) {
    return {
      original: _.toNumber(priceSplit[0]),
      price: parsePrice(priceSplit[0]),
      group: "All",
      subGroup: "",
    };
  }

  // ex. o_221
  if (priceSplit.length === 2) {
    return {
      original: _.toNumber(priceSplit[1]),
      price: parsePrice(priceSplit[1]),
      group: priceSplit[0],
      subGroup: "",
    };
  }

  // ex. o_221_1
  if (priceSplit.length === 3) {
    return {
      original: _.toNumber(priceSplit[1]),
      price: parsePrice(priceSplit[1]),
      group: priceSplit[0],
      subGroup: priceSplit[2],
    };
  }

  return {};
}
